/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Show_LessInputs */

const en_notes_show_less = /** @type {(inputs: Notes_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const pt_br2_notes_show_less = /** @type {(inputs: Notes_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menos`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Notes_Show_LessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_show_less = /** @type {((inputs?: Notes_Show_LessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Show_LessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_show_less(inputs)
	return pt_br2_notes_show_less(inputs)
});